import React, { useEffect, useRef, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "../styles/home.css";
import "swiper/css";
import "swiper/css/navigation";
import Typewriter from "typewriter-effect";
import { FaShoppingCart, FaPlay, FaEyeSlash, FaEye, FaStar } from "react-icons/fa";

export default function Home() {
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [step, setStep] = useState(1);
  const [isForgotMode, setIsForgotMode] = useState(false);

  const [loadingEmailBtn, setLoadingEmailBtn] = useState(false);
  const [loadingOtpBtn, setLoadingOtpBtn] = useState(false);
  const [loadingResetBtn, setLoadingResetBtn] = useState(false);

  // const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [resetPassword, setResetPassword] = useState("");


  const [showSoonPopup, setShowSoonPopup] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const desktopScrollRef = useRef(null); // desktop scroll
  const mobileScrollRef = useRef(null); // mobile scroll (if needed)
  const [toastMsg, setToastMsg] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showNewIssue, setShowNewIssue] = useState(false);

  const [bannerUrl, setBannerUrl] = useState("");
  const [offers, setOffers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [recentMagazines, setRecentMagazines] = useState([]);
  const [recentNews, setRecentNews] = useState([]);

  const [loadingMagazines, setLoadingMagazines] = useState(true);
  const [recentBooks, setRecentBooks] = useState([]);
  const [loadingBooks, setLoadingBooks] = useState(true);
  const [loading, setLoading] = useState(false);


  // Login form state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  // const [isLoggedIn, setIsLoggedIn] = useState(
  // !!localStorage.getItem("user"));
  // Top banner
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}banner_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const data = await response.json();
        if (data.head.code === 200 && data.body.length > 0) {
          // Take the first active banner
          setBannerUrl(data.body[0].banner_url);
        }
      } catch (error) {
        console.error("Error fetching banner:", error);
      }
    };

    fetchBanner();
  }, [API_BASE_URL]);

  //Ads Banner
  const [ads, setAds] = useState([]);
  const [soon, setSoon] = useState([]);
  const [navigateUrl, setNavigateUrl] = useState("");
  const [title, setTitle] = useState("");


  // Fetch ads from API
  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}adsbanner_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const data = await response.json();
        if (data.head.code === 200 && data.body.length > 0) {
          // Sort by rank if needed
          const sortedAds = data.body.sort(
            (a, b) => a.adsbanner_rank - b.adsbanner_rank,
          );
          const adsUrls = sortedAds.map((ad) => ad.adsbanner_url);
          setAds(adsUrls);
        } else {
          console.log("No ads found");
        }
      } catch (error) {
        console.error("Error fetching ads:", error);
      }
    };

    fetchAds();
  }, [API_BASE_URL]);

  // Fetch ads from API
  useEffect(() => {
    const fetchSoon = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}soonbanner_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });
        const data = await response.json();
        if (data.head.code === 200 && data.body.length > 0) {
          // Sort by rank if needed
          const sortedSoon = data.body.sort(
            (a, b) => a.adsbanner_rank - b.adsbanner_rank,
          );
          const adsUrls = sortedSoon.map((ad) => ad.adsbanner_url);
          const pdfUrls = sortedSoon.map((ad) => ad.navigate_url);

          setSoon(adsUrls);
          setNavigateUrl(pdfUrls);
          setTitle(data.body[0].title);
        } else {
          console.log("No ads found");
        }
      } catch (error) {
        console.error("Error fetching ads:", error);
      }
    };

    fetchSoon();
  }, [API_BASE_URL]);

  //offers content

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}offers_content_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });

        const data = await res.json();

        if (data.head.code === 200 && data.body.length > 0) {
          const htmlContent = data.body[0].content;

          // ✅ Extract P tags in order, NO trimming
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlContent, "text/html");

          const pTexts = Array.from(doc.getElementsByTagName("p")).map(
            (p) => p.textContent,
          ); // ← AS-IS

          setOffers(pTexts);
        }
      } catch (err) {
        console.error("Error fetching offers:", err);
      }
    };

    fetchOffers();
  }, [API_BASE_URL]);

  // popular category
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}subcategory_list.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });

        const data = await response.json();
        console.log("API Response:", data);

        if (data.head.code === 200 && data.body.length > 0) {
          // Sort the raw API data by subcategory_rank first
          const sortedRaw = data.body.sort((a, b) => {
            const rankA = Number(a.subcategory_rank) || 0; // ensure number
            const rankB = Number(b.subcategory_rank) || 0;
            return rankA - rankB; // ascending order
          });

          // Map to simplified objects after sorting
          const sortedCategories = sortedRaw.map((item) => ({
            name: item.subcategory_name,
            img: item.subcategory_image,
            mp_id: item.mp_id,
            sp_id: item.sp_id,
          }));

          console.log("Sorted Categories:", sortedCategories);

          setCategories(sortedCategories);
        } else {
          console.warn("No categories found:", data.head.msg);
          setCategories([]);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
        setCategories([]);
      } finally {
        setCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, [API_BASE_URL]);

  // Recent Magazines

  useEffect(() => {
    fetch(`${API_BASE_URL}recent_magazines_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.head?.code === 200) {
          setRecentMagazines(data.body);
        } else {
          setRecentMagazines([]);
        }
        setLoadingMagazines(false);
      })
      .catch((err) => {
        console.error("Recent magazines API error:", err);
        setLoadingMagazines(false);
      });
  }, [API_BASE_URL]);

  useEffect(() => {
    fetch(`${API_BASE_URL}daily_news_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.head?.code === 200) {
          setRecentNews(data.body);
        } else {
          setRecentNews([]);
        }
        setLoadingMagazines(false);
      })
      .catch((err) => {
        console.error("Recent News API error:", err);
        setLoadingMagazines(false);
      });
  }, [API_BASE_URL]);

  // Fetch recent books from API
  useEffect(() => {
    fetch(`${API_BASE_URL}recent_books_list.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.head?.code === 200) {
          setRecentBooks(data.body);
        } else {
          setRecentBooks([]);
        }
        setLoadingBooks(false);
      })
      .catch((err) => {
        console.error("Recent books API error:", err);
        setLoadingBooks(false);
      });
  }, [API_BASE_URL]);

  useEffect(() => {
    if (toastMsg) {
      const timer = setTimeout(() => setToastMsg(""), 2000);
      return () => clearTimeout(timer);
    }
  }, [toastMsg]);

  useEffect(() => {
    // const hasSeenModal = localStorage.getItem("hasSeenNewIssue");

    // if (!hasSeenModal) {
    //   setShowNewIssue(true);
    //   localStorage.setItem("hasSeenNewIssue", "true");
    // }
    setShowNewIssue(true);

    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer);
  }, []);

  const addToCart = (book) => {
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const currentStock = Number(book.stock) || 0;

    // 1. Initial Check: Is the book out of stock?
    if (currentStock <= 0) {
      setToastMsg(`Sorry, ${book.product_name} is out of stock! ⚠️`);
      return;
    }

    const cartId = `book-${book.product_id}-${book.mp_id}-${book.sp_id}`;
    const existingIndex = cart.findIndex((item) => item.id === cartId);

    if (existingIndex !== -1) {
      // 2. Check if incrementing exceeds stock
      if (cart[existingIndex].quantity + 1 > currentStock) {
        setToastMsg(`Only ${currentStock} copies available in stock! ⚠️`);
        return;
      }
      cart[existingIndex].quantity += 1;
    } else {
      // 3. New entry: include the stock value for Cart Page validation
      cart.push({
        id: cartId,
        mpid: book.mp_id,
        spid: book.sp_id,
        code: book.product_code,
        product_id: book.product_id,
        title: book.product_name,
        image: book.product_url,
        price: book.online_rate,
        mrp: book.mrp_rate,
        tax: book.product_tax,
        quantity: 1,
        stock: currentStock, // ✅ Crucial for Cart Page validation
        itemType: "book",
        type: "Hardcopy",
        plan: "Single",
      });
    }

    localStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cartUpdated"));

    // ✅ Success toast
    setToastMsg(`Book added to cart! 🛒`);
  };

  const handleCategoryClick = ({ mp_id, sp_id }) => {
    navigate(`/magazines?mp_id=${mp_id}&sp_id=${sp_id}`);
  };
  // desktop auto-scroll
  useEffect(() => {
    if (!desktopScrollRef.current || ads.length <= 3) return;

    const container = desktopScrollRef.current;
    let currentIndex = 0;
    const children = container.children;
    if (!children.length) return;

    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % children.length;
      const scrollLeft = children[currentIndex].offsetLeft;
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [ads]);

  // Mobile auto-scroll
  useEffect(() => {
    if (!mobileScrollRef.current) return;

    const container = mobileScrollRef.current;
    let currentIndex = 0;
    const children = container.children;
    if (!children.length) return;

    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % children.length;
      const scrollLeft = children[currentIndex].offsetLeft;
      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }, 3000); // change speed here if needed

    return () => clearInterval(interval);
  }, [ads]);

  const formattedMagazines = useMemo(() => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return recentMagazines.map((mag) => {
      const date = new Date(mag.publish_date);

      const formattedDate = !isNaN(date)
        ? `${months[date.getMonth()]} ${date.getFullYear()}`
        : "";

      return {
        ...mag,
        formattedDate,
      };
    });
  }, [recentMagazines]);

  const [showVideo, setShowVideo] = useState(false);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}user_login.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_mail: email,
          user_password: password,
        }),
      });

      const data = await response.json();
      console.log("Login API Response:", data);

      if (data.head.code === 200) {
        // Save user info
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: data.body.user_name,
            email: email,
            user_id: data.body.user_id,
          }),
        );
        localStorage.setItem("isLoggedIn", "true");
        setShowPopup(false);
      } else {
        setError(data.head.msg || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Server error. Please try again.");
    }
  };

  const pageLoading = categoriesLoading || loadingMagazines || loadingBooks;

  //page loader

  const PageLoader = () => {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#ffffff",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
        />
        <p className="mt-3 fw-semibold">Loading Porvaall...</p>
      </div>
    );
  };

  const handleSendOtp = async (e) => {
    setLoadingEmailBtn(true);
    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}forgot_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_mail: email,
        }),
      });

      const data = await response.json();
      console.log("=========== ", data.head.code);
      if (data.head.code === 200) {
        // Save logged-in user info for Navbar

        localStorage.setItem("userId", data.body.user_id);
        console.log("=========== ");
        // Redirect logic
        setLoadingEmailBtn(false);
        setError("");


        setStep(2);
      } else {
        setLoadingEmailBtn(false);
        setError(data.head.msg);
        console.log("=========== ", data.head.msg);
        // setError(data.head.msg || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleVerifyOtp = async (e) => {
    setLoadingOtpBtn(true);

    e.preventDefault();
    try {
      const response = await fetch(`${API_BASE_URL}verify_email_otp.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_mail: email,
          otp: otp,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // Save logged-in user info for Navbar

        // localStorage.setItem("isLoggedIn", "true");

        // Redirect logic
        setError("");
        setLoadingOtpBtn(false);


        setStep(3);
      } else {
        setLoadingOtpBtn(false);
        setError(data.head.msg);
      }
    } catch (err) {
      setLoadingOtpBtn(false);
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleResetPassword = async (e) => {
    setLoadingResetBtn(true);

    e.preventDefault();
    const userId = localStorage.getItem("userId");
    try {
      const response = await fetch(`${API_BASE_URL}update_password.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: userId,
          password: resetPassword,
        }),
      });

      const data = await response.json();

      if (data.head.code === 200) {
        // Save logged-in user info for Navbar

        // localStorage.setItem("isLoggedIn", "true");

        // Redirect logic
        alert("Password reset successful!");
        setLoadingResetBtn(false);

        setError("");
        setEmail("");
        setOtp("");
        setResetPassword("");

        setIsForgotMode(false);
        setStep(1);

      } else {
        setLoadingResetBtn(false);
        setError(data.head.msg);
      }
    } catch (err) {
      console.error("Login API error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {pageLoading && <PageLoader />}
      <div className="page-container">
        {toastMsg && (
          <div className="toast-message fw-semibold">{toastMsg}</div>
        )}

        {/* Popup */}
        {!isLoggedIn && showPopup && (
          <div className="login-popup-overlay">
            <div className="login-popup-box">

              {/* Close */}
              <button
                className="popup-close-btn"
                onClick={() => {
                  setError("");
                  setEmail("");
                  setOtp("");
                  setResetPassword("");
                  setShowPopup(false);
                  setIsForgotMode(false);
                  setStep(1);
                }}
              >
                ✕
              </button>

              {/* ================= LOGIN MODE ================= */}
              {!isForgotMode && (
                <>
                  <h3 className="text-center mb-3 fw-bold">Welcome To Porvaall</h3>

                  {error && <div className="alert alert-danger">{error}</div>}

                  <form onSubmit={handleEmailLogin}>
                    <div className="mb-3 text-start">
                      <label className="form-label fw-semibold">Enter your Gmail</label>
                      <input
                        type="email"
                        className="form-control form-control-lg"
                        placeholder="example@gmail.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    <div className="mb-3 text-start password-container">
                      <label className="form-label fw-semibold">Password</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control form-control-lg"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span
                        className="password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>

                    <button className="btn btn-primary w-100 fw-semibold py-2">
                      Login
                    </button>
                  </form>

                  <p className="text-center mt-4 text-muted small-text">
                    Don’t have an account?{" "}
                    <span
                      className="text-primary fw-semibold cursor-pointer"
                      onClick={() => navigate("/signup")}
                    >
                      Sign Up
                    </span>
                  </p>

                  <p className="text-end mt-2">
                    <span
                      className="text-primary cursor-pointer"
                      onClick={() => setIsForgotMode(true)}
                    >
                      Reset / Forgot Password?
                    </span>
                  </p>
                </>
              )}

              {/* ================= FORGOT MODE ================= */}
              {isForgotMode && (
                <>
                  <h3 className="text-center mb-3 fw-bold">Reset Password</h3>

                  {/* STEP 1 */}
                  {step === 1 && (
                    <>
                      <input
                        type="email"
                        className="form-control form-control-lg mb-3"
                        placeholder="Enter registered email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {error && (
                        <div className="alert alert-danger mt-2">
                          {error}
                        </div>
                      )}                      <button className="btn btn-primary w-100" onClick={handleSendOtp}>
                        {loadingEmailBtn ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Processing...
                          </>
                        ) : (
                          "Send OTP"
                        )}
                      </button>
                    </>
                  )}

                  {/* STEP 2 */}
                  {step === 2 && (
                    <>
                      <input
                        type="text"
                        className="form-control form-control-lg mb-3"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                      {error && (
                        <div className="alert alert-danger mt-2">
                          {error}
                        </div>
                      )}
                      <button className="btn btn-primary w-100" onClick={handleVerifyOtp}>
                        {loadingOtpBtn ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Processing...
                          </>
                        ) : (
                          "Verify OTP"
                        )}
                      </button>
                    </>
                  )}

                  {/* STEP 3 */}
                  {step === 3 && (
                    <>
                      {/* <input
                        type="password"
                        className="form-control form-control-lg mb-3"
                        placeholder="Enter new password"
                        value={resetPassword}
                        onChange={(e) => setResetPassword(e.target.value)}
                      /> */}
                      <div className="position-relative mb-3">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control form-control-lg pe-5"
                          placeholder="Enter new password"
                          value={resetPassword}
                          onChange={(e) => setResetPassword(e.target.value)}
                        />

                        {/* Eye Icon */}
                        <span
                          onClick={() => setShowPassword(!showPassword)}
                          style={{
                            position: "absolute",
                            right: "15px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "18px",
                          }}
                        >
                          {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </span>
                      </div>
                      {error && (
                        <div className="alert alert-danger mt-2">
                          {error}
                        </div>
                      )}
                      <button className="btn btn-success w-100" onClick={handleResetPassword}>
                        {loadingResetBtn ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Processing...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </>
                  )}

                  {/* BACK */}
                  <p className="text-center mt-3">
                    <span
                      className="text-primary cursor-pointer"
                      onClick={() => {
                        setError("");
                        setEmail("");
                        setOtp("");
                        setResetPassword("");
                        setIsForgotMode(false);
                        setStep(1);
                      }}
                    >
                      Back to Login
                    </span>
                  </p>
                </>
              )}

            </div>
          </div>
        )}

        {/* FORGOT PASSWORD MODE */}


        {showNewIssue && (
          <div className="modal fade text-center show d-block" tabIndex="-1"

          >
            <div className="modal-dialog new-issue modal-dialog-centered">
              <div className="modal-content   text-dark">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-dark"
                    onClick={() => setShowNewIssue(false)}
                  />
                </div>

                <div className="modal-body text-center"
                  // onClick={() => {
                  //   const fullUrl = navigateUrl;
                  //   const path = new URL(fullUrl).pathname;
                  //   navigate(path);
                    
                  //   // navigate(`/subscription/${formattedMagazines[0].product_id}?mp_id=${formattedMagazines[0].mp_id}&sp_id=${formattedMagazines[0].sp_id}`);
                  //   // navigate(`${navigateUrl}`);
                  //   // console.log("Clicked on New Issue popup", navigateUrl);
                  //   window.scrollTo(0, 0);
                  // }}
                  // onClick={() => {
                  //                           // const baseUrl = "https://porvaall.com/PMadmin/admin_api/";
                  //                           // const fullPdfUrl = `${baseUrl}${book.pdf_file}`;
                  //                           window.open(navigateUrl, "_blank", "noopener,noreferrer");
                  //                       }}
                  onClick={() => {
  navigate("/pdf-viewer", {
    state: {
      pdfUrl: navigateUrl,
      title: "New Issue", // or pass the magazine title if you have it
    },
  });
  window.scrollTo(0, 0);
}}
                >
                  {soon.map((img, index) => (
                    <img
                      style={{
                        // height: "400px",
                        // width: "300px"
                      }}
                      src={img}
                      alt="Coming Soon"
                      className="img-fluid rounded"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

        )}

        {/* HERO SECTION */}
        <motion.section
          className="py-5 topclass d-flex flex-column align-items-center justify-content-center position-relative"
          style={{
            backgroundImage: bannerUrl ? `url(${bannerUrl})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "400px",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <div className="container-fluid text-center text-white">
            <h1 className="fw-bold readingbooks">Welcome to Porvaall</h1>
            <p className="lead">Discover top magazines & trending articles</p>

            <button
              className="btn rounded-circle p-3 shadow play-btn"
              onClick={() => setShowVideo(true)}
            >
              <FaPlay size={24} className="text-white" />
            </button>
            <br />

            <Link
              to="/videos"
              className="btn btn-warning btn-lg mt-3 view-btn1"
              onClick={() => window.scrollTo(0, 0)}
            >
              More Videos
            </Link>
          </div>
        </motion.section>

        {/* VIDEO OVERLAY */}
        {showVideo && (
          <div
            className="video-overlay d-flex justify-content-center align-items-center"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.8)",
              zIndex: 9999,
            }}
          >
            <div className="position-relative">
              <button
                onClick={() => setShowVideo(false)}
                style={{
                  position: "absolute",
                  top: "-40px",
                  right: "0",
                  background: "transparent",
                  color: "#fff",
                  border: "none",
                  fontSize: "30px",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>

              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/ohrJRCMW98o?si=zH9EvnleZlfi77YP"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}

        {/* POPULAR CATEGORIES 
        <section className="py-3">
          <div className="container-fluid">
            <div className="d-flex justify-content-between mb-3">
              <h4>Magazine Categories</h4>
              <Link
                className="viewalllinks"
                to="/magazines"
                onClick={() => window.scrollTo(0, 0)}
              >
                View All
              </Link>
            </div>

            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              // loop
              autoplay={{ delay: 2500 }}
              spaceBetween={15}
              slidesPerView={2}
              breakpoints={{
                425: { slidesPerView: 3 },
                576: { slidesPerView: 4 },
                768: { slidesPerView: 5 },
                992: { slidesPerView: 6 },
                1200: { slidesPerView: 8 },
              }}
            >
              {categoriesLoading ? (
                <p>Loading categories...</p>
              ) : (
                categories.map((cat, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="category-box"
                      style={{ backgroundImage: `url(${cat.img})` }}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        handleCategoryClick({
                          mp_id: cat.mp_id,
                          sp_id: cat.sp_id,
                        });
                      }}
                    >
                      <div className="overlay">
                        <h6>{cat.name}</h6>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              )}
            </Swiper>
          </div>
        </section>
        */}

        {/* Daily News */}
        <section className="py-3">
          <div className="container-fluid">
            <div className="d-flex justify-content-between mb-3">
              <h4>Daily News</h4>
              <Link
                className="viewalllinks"
                to="/dailyNews"
                onClick={() => window.scrollTo(0, 0)}
              >
                View All
              </Link>
            </div>

            {loadingMagazines ? (
              <div className="text-center py-4">Loading magazines...</div>
            ) : recentNews.length === 0 ? (
              <div className="text-center py-4">No magazines available</div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={recentNews.length > 6}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                spaceBetween={15}
                slidesPerView={1}
                breakpoints={{
                  375: { slidesPerView: 2 },
                  425: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 5 },
                  1200: { slidesPerView: 6 },
                }}
              >
                {recentNews.map((news) => (
                  <SwiperSlide key={news.news_id}>
                    <div
  className="viewalllinks"
  style={{ cursor: "pointer", textDecoration: "none", color: "inherit" }}
  // onClick={() => {
  //   // 1. Open the PDF in a new tab
  //   const baseUrl = "https://porvaall.com/PMadmin/admin_api/";
  //   const fullPdfUrl = `${baseUrl}${news.pdf_file}`;
  //   window.open(fullPdfUrl, "_blank", "noopener,noreferrer");

  //   // 2. Scroll the main page back to the top
  //   window.scrollTo(0, 0);
  // }}
  onClick={() => {
  navigate("/pdf-viewer", {
    state: {
      pdfUrl: `https://porvaall.com/PMadmin/admin_api/${news.pdf_file}`,
      title: news.title,
    },
  });
  window.scrollTo(0, 0);
}}
>
  <div className="card shadow-sm h-100">
    <img
      src={news.cover_image}
      className="card-img-top"
      alt="Magazine"
      style={{
        height: "220px",
        objectFit: "contain",
      }}
    />
    <div className="card-body text-center">
      <h6>{news.title}</h6>
      <h6>
        {new Date(news.publishdate)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-")}
      </h6>
    </div>
  </div>
</div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </section>

        {/* RECENT MAGAZINES */}
        <section className="py-3">
          <div className="container-fluid">
            <div className="d-flex justify-content-between mb-3">
              <h4>Recent Magazines</h4>
              <Link
                className="viewalllinks"
                to="/magazines"
                onClick={() => window.scrollTo(0, 0)}
              >
                View All
              </Link>
            </div>

            {loadingMagazines ? (
              <div className="text-center py-4">Loading magazines...</div>
            ) : recentMagazines.length === 0 ? (
              <div className="text-center py-4">No magazines available</div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={formattedMagazines.length > 6}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                spaceBetween={15}
                slidesPerView={1}
                breakpoints={{
                  375: { slidesPerView: 2 },
                  425: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 5 },
                  1200: { slidesPerView: 6 },
                }}
              >
                {formattedMagazines.map((mag) => (
                  <SwiperSlide key={mag.product_id}>
                    <Link
                      className="viewalllinks"
                      to={`/subscription/${mag.product_id}?mp_id=${mag.mp_id}&sp_id=${mag.sp_id}`}
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <div className="card shadow-sm h-100">
                        <img
                          src={mag.product_url}
                          className="card-img-top"
                          alt="Magazine"
                          style={{
                            height: "220px",
                            objectFit: "contain",
                          }}
                        />
                        <div className="card-body text-center">
                          <h6>{mag.formattedDate}</h6>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </section>

        {/* ADS BANNER */}
        {ads.length > 0 && (
          <section className="py-3">
            <div className="container-fluid">
              <Swiper
                modules={[Autoplay]}
                loop={ads.length > 2}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                spaceBetween={16}
                slidesPerView={1}
                breakpoints={{
                  576: { slidesPerView: 1 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 3 },
                }}
              >
                {ads.map((img, index) => (
                  <SwiperSlide key={index}>
                    <a
                      href="https://sdspc.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={img}
                        className="responsive-img"
                        alt={`Ads ${index + 1}`}
                      />
                    </a>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </section>
        )}


        {/* RECENT BOOKS */}
        <section className="py-3">
          <div className="container-fluid">
            <div className="d-flex justify-content-between mb-3">
              <h4>Recent Books</h4>
              <Link
                className="viewalllinks"
                to="/articles"
                onClick={() => window.scrollTo(0, 0)}
              >
                View All
              </Link>
            </div>

            {loadingBooks ? (
              <div className="text-center py-4">Loading books...</div>
            ) : recentBooks.length === 0 ? (
              <div className="text-center py-4">No books available</div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={recentBooks.length > 2}
                loopFillGroupWithBlank={true}
                observer={true}
                observeParents={true}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                spaceBetween={15}
                slidesPerView={1}
                breakpoints={{
                  375: { slidesPerView: 2 },
                  425: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 5 },
                  1200: { slidesPerView: 6 },
                }}
              >
                {recentBooks.map((book) => (
                  <SwiperSlide key={book.product_id || book.id}>
                    <div className="card shadow-sm p-2 book-card h-100">
                      <img
                        src={book.product_url}
                        className="book-img swiper-book-img"
                        alt={book.product_name}
                        style={{ height: "220px", objectFit: "contain" }}
                        onClick={() => {
                          window.scrollTo(0, 0);
                          navigate(
                            `/bookdescription/${book.product_id || book.id}?mp_id=${book.mp_id}&sp_id=${book.sp_id}`
                          );
                        }}
                      />

                      <p className="mt-2 text-center fw-semibold">
                        {book.product_name.length > 15
                          ? book.product_name.slice(0, 15)
                          : book.product_name}
                        {book.product_name.length > 15 && <span>...</span>}
                      </p>

                      <p className="text-center mb-2">
                        <span className="fw-bold text-success me-2">
                          ₹{book.online_rate}
                        </span>
                        {Number(book.mrp_rate) > 0 && (
                          <span className="text-danger text-decoration-line-through">
                            ₹{book.mrp_rate}
                          </span>
                        )}
                      </p>

                      <button
                        className="add-to-cart-btn1 w-100"
                        onClick={() => addToCart(book)}
                        disabled={Number(book.stock) <= 0}
                        style={{
                          backgroundColor:
                            Number(book.stock) <= 0 ? "#ccc" : "",
                          cursor:
                            Number(book.stock) <= 0
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <FaShoppingCart size={16} className="me-2" />
                        {Number(book.stock) <= 0
                          ? "Out of Stock"
                          : "Add to Cart"}
                      </button>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </section>


        {/* INSPIRATION */}
        <section className="middlesection text-white text-start d-flex align-items-center">
          {/* <div className="p-4">
            <h1 className="fw-bold mb-3 readingbooks">
              Magazines
            
            </h1>
            <p className="lead mb-4">
              Stay tuned for what’s coming next, explore the current issue.
            </p>
            <div className="d-flex justify-content-between">
              <button
                className="btn btn-dark btn-lg view-btn"
                // onClick={() => {
                //   navigate("/magazines");
                //   window.scrollTo(0, 0);
                // }}
                onClick={() => setShowSoonPopup(true)}
              >
               
                🚀 Coming Soon

              </button>

              <button
                className="price-list-btn"
                //  className="btn animated-btn btn-lg"
                onClick={() => {
                  // console.log("=====from api ====",formattedMagazines[0]);
                  navigate(`/subscription/${formattedMagazines[0].product_id}?mp_id=${formattedMagazines[0].mp_id}&sp_id=${formattedMagazines[0].sp_id}`);
                  window.scrollTo(0, 0);
                }}
              >
               
                <FaStar className="" style={{ size: "16px" }} /> New Release

              </button>
            </div>
          </div> */}
        </section>

        {/* EXCLUSIVE OFFERS 
        <section className="offers-section text-center text-light d-flex align-items-center">
          <div className="offers-glass p-4">
            <p className="fw-bold mb-3 offerheading">🔥 Exclusive Offers 🔥</p>

            <h3 className="text-light">
              <span className="typing-text">
                <Typewriter
                  options={{
                    strings: offers,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </span>
            </h3>

            <button
              className="btn btn-dark btn-lg view-btn mt-3 expbtn"
              onClick={() => {
                navigate("/magazines");
                window.scrollTo(0, 0);
              }}
            >
              Explore Now
            </button>
          </div>
        </section>
        */}
      </div>

      {/* Popup */}
      {showSoonPopup && (
        <div className="modal fade show d-block" tabIndex="-1" >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content  text-dark">
              <div className="modal-header">
                <h5 className="modal-title">Coming Soon</h5>
                <button
                  type="button"
                  className="btn-close btn-close-dark"
                  onClick={() => setShowSoonPopup(false)}
                />
              </div>

              <div className="modal-body text-center">
                {soon.map((img, index) => (
                  <img
                    style={{
                      height: "600px",
                      width: "500px"
                    }}
                    src={img}
                    alt="Coming Soon"
                    className="img-fluid rounded"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {showSoonPopup && <div className="modal-backdrop fade show"></div>}


    </>
  );
}
